import { render, staticRenderFns } from "./CustomerServiceFaq.vue?vue&type=template&id=e66be36e&scoped=true&"
import script from "./CustomerServiceFaq.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceFaq.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceFaq.vue?vue&type=style&index=0&id=e66be36e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66be36e",
  null
  
)

export default component.exports